import { useEffect } from "react";
import {
  getUserInvestmentsRequest,
  getUserRequest,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useParams } from "react-router";
import { ProfileForm } from "../../../components/Form/ProfileForm.js";
import {
  AdminSideNav,
  AuthNav,
} from "../../../components/Navbar/Webpages/AuthNav.jsx";

const EditUser = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    getUserSuccess,
    getUserError,
    getUserLoading,
    user,
    singleUser,
    updateUserSuccess,
    updateUserError,
    updateUserLoading,
    getUserInvestmentsError,
    investments,
    getUserInvestmentsLoading,
  } = useSelector((state) => {
    const {
      success: {
        getUser: getUserSuccess,
        updateUser: updateUserSuccess,
        getUserInvestments: getUserInvestmentsSuccess,
      },
      errors: {
        getUser: getUserError,
        updateUser: updateUserError,
        getUserInvestments: getUserInvestmentsError,
      },
    } = state.ajaxStatuses;

    const { getUserLoading, updateUserLoading, getUserInvestmentsLoading } =
      state.loadingIndicator;

    const { user, singleUser } = state.userData;
    const { investments } = state.investmentData;

    return {
      getUserSuccess,
      getUserError,
      getUserLoading,
      singleUser,
      user,
      updateUserSuccess,
      updateUserError,
      updateUserLoading,
      getUserInvestmentsError,
      investments,
      getUserInvestmentsLoading,
    };
  });

  useEffect(() => {
    dispatch(getUserRequest(id));
    dispatch(getUserInvestmentsRequest(id));
  }, [getUserRequest, getUserInvestmentsRequest]);

  useEffect(() => {
    if (getUserError) {
      toast.error(getUserError, {
        duration: 3000,
      });
    }
  }, [getUserError]);

  useEffect(() => {
    if (getUserInvestmentsError) {
      toast.error(getUserInvestmentsError, {
        duration: 3000,
      });
    }
  }, [getUserInvestmentsError]);
  return (
    <div className="bg-gray-50 min-h-screen">
      <AuthNav title={"Edit User"} />
      <AdminSideNav />

      <div className="pb-20 pt-10 md:pt-24">
        <ProfileForm user={singleUser} loading={getUserLoading} />
      </div>
    </div>
  );
};

export default EditUser;
